import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useCustomFetchCategories } from '../hooks/useCustomFetchCategories'
import { useNavigate, useParams } from 'react-router-dom'
import { useCustomFetchDetail } from '../hooks/UseCustomFetchDetail'
import customFetchUpdateRecord from '../hooks/customFetchUpdateRecord'
import Swal from 'sweetalert2'
import { useFormik } from 'formik'
import * as Yup from 'yup';



const RecordsUpdate = () => {
  // const { dataCategories } = useCustomFetchCategories("http://localhost:3001/records/categories")
  const { dataCategories } = useCustomFetchCategories("https://cold-forest-1856.fly.dev/records/categories")
  const { categories } = !!dataCategories && dataCategories;


  const idParam = useParams().id
  // const { dataDetail } = useCustomFetchDetail(`http://localhost:3001/records/detail/${idParam}`)
  const { dataDetail } = useCustomFetchDetail(`https://cold-forest-1856.fly.dev/records/detail/${idParam}`)
  const { data } = !!dataDetail && dataDetail
  const [conceptDetail, setConceptDetail] = useState("");
  const [amountDetail, setAmountDetail] = useState("");
  const [tipeDetail, setTipeDetail] = useState("");
  const [idCategoryDetail, setIdCategoryDetail] = useState("");
  const [dateDetail, setDateDetail] = useState("");

  useEffect(() => {
    if (data) {
      setConceptDetail(data.concept)
      setAmountDetail(data.amount)
      setTipeDetail(data.tipe)
      setIdCategoryDetail(data.category_id)
      setDateDetail(data.created_at)
    }

  }, [data])

  const onSubmit = (event) => {

    // customFetchUpdateRecord(`http://localhost:3001/records/update/${idParam}`, [concept.field, amount.field, category.field, tipe.field, userId, date.field])
    customFetchUpdateRecord(`https://cold-forest-1856.fly.dev/records/update/${idParam}`, [values.concept, values.amount, values.categories, values.tipe, userId, values.date])
      .then(
        (response) =>
          response.json()
      )
      .then(data => {
        Swal.fire({

          title: "Record Updated",
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: '#0d6efd',

        })
          .then((result) => {
            if (result.isConfirmed) {
              navigate(-1)

            }
          })



      })

  }



const UpdateSchema = Yup.object().shape({
   concept: Yup.string()
     .min(2, 'Min 2 characters')
     .required('Please write a concept'),
   amount: Yup.number()
     .required('Please write an amount')
     .max(1000000),
     categories: Yup.string()
     .required("Please select a category"),
     date: Yup.string()
     .required("please select a date")
   
 });

  const {values,errors,handleBlur,handleChange,handleSubmit} = useFormik({

    initialValues: {
      concept: conceptDetail,
      amount: amountDetail,
      tipe: tipeDetail,
      categories: idCategoryDetail,
      date: dateDetail

    },
    enableReinitialize: true,
    validationSchema : UpdateSchema,
    onSubmit,
  })

  const userInSession = JSON.parse(sessionStorage.getItem("user"))

  const [userId, setUserId] = useState("")
  const navigate = useNavigate();
  useEffect(() => {
    if (userInSession) {
      setUserId(userInSession.id)
    }
  }, [userInSession])


  

console.log(errors)

  return (
    <div className='div-dash'>
      <h1 className='text-center'>Update Record</h1>
      <form
        className='p-5 form-create'
        onSubmit={handleSubmit}

      >
        <div className="mb-3">
          <label className='form-label' htmlFor="concept">Concept*</label>
          <input
            name='concept'
            className={ errors.concept ? "border-red form-control" : "form-control"}
            type="text"
            onChange={handleChange}
            value={values.concept}
            id="inputConcept"
            onBlur={handleBlur}

          />

          <div id="conceptHelp"  className={errors.concept ? "form-text errorText show" : "form-text errorText none"}>Please, write the concept. Min 2 characters  </div>

        </div>
        <div className="mb-3">
          <label className='form-label' htmlFor="amount">Amount*</label>
          <input
            name="amount"
            className={ errors.amount ? "border-red form-control" : "form-control"}
            type="number"
            onChange={handleChange}
            value={values.amount}
            id="inputAmount"
            onBlur={handleBlur}

          />
          <div id="amountHelp" className={errors.amount ? "form-text errorText show" : "form-text errorText none"}>Write the Amount, max $1.000.000</div>
        </div>
        <div className="mb-3">
          <label className='form-label' htmlFor="date">Date*</label>
          <input
            name="date"
            className={ errors.date ? "border-red form-control" : "form-control"}
            type="date"
            onChange={handleChange}
            value={values.date}
            id="inputDate"
            onBlur={handleBlur}


          />
        </div>
        <div id="dateHelp" className={errors.date ? "form-text errorText show" : "form-text errorText none"}>Please write or select a date</div>
        <div className='container-select '>
          <div className="mb-3">
            <div htmlFor="tipe" className='select-title'>Tipe</div>
            <select
              name="tipe"
              onChange={handleChange}
              className="select-form"
              id='inputTipe'

            >
              {
                tipeDetail === "Income" ?
                  (<option
                    selected={tipeDetail === "Income"}
                    value={values.tipe}>Income</option>)
                  :
                  (
                    <option
                      selected={tipeDetail === "Expense"}
                      value={values.tipe}>Expense</option>

                  )
              }
            </select>
            <div id="emailHelp" className="form-text">You cannot change the tipe</div>
          </div>
          <div className="mb-3">
            <div htmlFor="tipe" className='select-title'>Categories</div>

            <select
              name="categories"
              as="select"
              onChange={handleChange}
              onBlur={handleBlur}
              className={ errors.categories ? "border-red select-form" : "select-form"}
              id='inputCategory'

            >
              <option disabled selected> Seleccionar</option>
              {
                categories ?
                  (
                    categories.map(categoria => {
                      return (
                        <option
                          key={categoria.id}
                          value={categoria.id}
                          selected={categoria.id === idCategoryDetail}>
                          {categoria.name}
                        </option>

                      )

                    })
                  )
                  :
                  (
                    <option>cargando</option>

                  )
              }
            </select>
          </div>

        </div>
        <div id="categoriesHelp" className={errors.categories ? "form-text errorText show" : "form-text errorText none"}>Please select a category</div>

        <button
          type='submit'
          className='btn btn-outline-dark btn-form-create'
        >
          Update</button>

      </form>

    </div>
  )
}

export default RecordsUpdate